import { Button } from "@/components/flexkit/Button";
import { Nudge } from "@/components/nudges/Nudge";
import { ExternalLink } from "@/components/podkit/typography/ExternalLink";
import { Text } from "@/components/podkit/typography/Text";
import { NudgeKeys, useNudges } from "@/hooks/use-nudges";
import { TrackLocations } from "@/hooks/use-segment";
import { useSetPreference } from "@/queries/user-preferences-queries";
import { useCallback, useEffect, useState, type FC } from "react";

export const FromGitpodToOnaNudge: FC = () => {
    const { active: nudge, error, isPending } = useNudges();
    const { mutate: setPreference } = useSetPreference();
    const [open, setOpen] = useState(false);

    // Auto-show nudge if applicable
    useEffect(() => {
        if (isPending || error) {
            return;
        }

        if (nudge?.key === NudgeKeys.FROM_GITPOD_TO_ONA) {
            setOpen(true);
            return;
        }
        setOpen(false);
    }, [isPending, error, nudge?.key]);

    const toggleOpen = useCallback(() => {
        setOpen((previousOpenState) => {
            const isNowOpen = !previousOpenState;
            if (!isNowOpen) {
                setPreference({
                    key: NudgeKeys.FROM_GITPOD_TO_ONA,
                    value: new Date().toISOString(),
                });
            }
            return isNowOpen;
        });
    }, [setPreference]);

    const ariaLabelPrefix = "Announcement - From Gitpod to Ona";

    return (
        <Nudge
            open={open}
            toggleOpen={toggleOpen}
            ariaLabelPrefix={ariaLabelPrefix}
            data-testid="nudge-from-gitpod-to-ona-trigger"
            data-track-location={TrackLocations.FromGitpodToOnaNudge}
        >
            <div className="flex flex-col gap-2">
                <div className="p-2 text-center">
                    <Text className="text-base font-bold text-content-primary">From Gitpod to Ona</Text>
                    <Text className="text-base text-content-secondary">
                        Get $100 in free credits in our Core tier (ending soon).
                    </Text>
                </div>
                <div className="flex flex-col gap-2">
                    <Button
                        variant="primary"
                        size="md"
                        className="grow"
                        aria-label={`${ariaLabelPrefix} - Read launch blog post`}
                        asChild
                    >
                        <ExternalLink href="https://ona.com/stories/gitpod-is-now-ona" iconSize="sm">
                            Read launch blog post
                        </ExternalLink>
                    </Button>
                </div>
            </div>
        </Nudge>
    );
};
